import React from 'react';
import ReactDOM from 'react-dom';
import getLogonProfile from './getLogonProfile';
import UserMenu from './UserMenu';

const { theme } = document.querySelector('body').dataset;

ReactDOM.render(
  <UserMenu getLogonProfile={getLogonProfile} themeName={theme} />,
  document.getElementById('userMenuApp'),
);
